import * as XLSX from "xlsx";

const SHEET_NAME = "Inward";
const FILENAME = "inward_upload_format.xlsx";
const TEMPLATE_HEADERS = [
 "Invoice Number",
 "Invoice Date",
 "Company",
 "Product SKU",
 "Product Description",      // ✅ NEW
 "Product Temperature",
 "Invoice Quantity",
 "Received Quantity",
 "Dock Number",
 "Dock In Time",
 "Dock Out Time",
 "Vehicle Number",
 "Vehicle Temperature",
 "Location",
 "Batch Number",
 "Manufacturing Date",
 "Expiry Date",
 "Batch Quantity",
 "Condition",
 "Bin Code",
];
const INSTRUCTIONS_ROW = [
 "e.g. INV-001 (required, same invoice = multiple products)",
 "YYYY-MM-DD (required)",
 "Company name(s), comma separated for multiple (optional)",
 "Product SKU(s), comma separated for multiple (required)",
 "Product description (optional) - keep same order as SKU list", // ✅ NEW
 "number (optional) e.g. 4 or 4.5",
 "number > 0 (required)",
 "number >= 0 (required)",
 "optional (e.g. D-01)",
 "YYYY-MM-DD HH:mm (optional) or Excel datetime",
 "YYYY-MM-DD HH:mm (optional) or Excel datetime",
 "optional",
 "number (optional) e.g. 2 or 2.5",
 "optional (e.g. Warehouse A)",
 "Batch number for these batches (optional, kept as-is in system)",
 "Manufacturing date(s), comma separated for multiple batches (required)",
 "Expiry date(s), comma separated for multiple batches (required)",
 "Batch quantity(s), comma separated (sum must equal received qty) (required)",
 "Condition(s), comma separated for multiple batches (GOOD/DAMAGED/EXPIRED)",
 "Bin code(s), comma separated for multiple batches (required)",
];

const SAMPLE_ROW_1 = [
 "INV-001",
 "2025-02-01",
 "Company A, Company B",
 "SKU-001, SKU-002",
 "Desc for SKU-001, Desc for SKU-002", // ✅ NEW
 4,
 100,
 100,
 "D-01",
 "2025-02-01 10:00",
 "2025-02-01 11:30",
 "VEH-001",
 2,
 "Warehouse A",
 "BATCH-INV001-01",
 "2025-01-01, 2025-01-15",
 "2026-01-01, 2026-01-15",
 "50, 50",
 "GOOD",
 "A-01-01, A-01-02",
];

const SAMPLE_ROW_2 = [
 "INV-002",
 "2025-02-02",
 "Company C",
 "SKU-003",
 "Desc for SKU-003", // ✅ NEW
 5,
 80,
 60,
 "D-02",
 "2025-02-02 09:10",
 "2025-02-02 10:00",
 "VEH-002",
 3,
 "Warehouse B",
 "BATCH-INV002-01",
 "2025-01-02, 2025-01-01",
 "2025-01-31, 2025-01-29",
 "50, 10",
 "DAMAGED, GOOD",
 "HOLD-BIN-001, GOOD-BIN-001",
];



export function downloadInwardUploadTemplate() {
  const wsData = [
    TEMPLATE_HEADERS,
    INSTRUCTIONS_ROW,
    SAMPLE_ROW_1,
    SAMPLE_ROW_2,
  ];

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Column widths
  ws["!cols"] = [
   { wch: 16 }, // Invoice Number
   { wch: 14 }, // Invoice Date
   { wch: 30 }, // Company
   { wch: 30 }, // Product SKU
   { wch: 35 }, // ✅ Product Description (NEW)
   { wch: 18 }, // Product Temperature
   { wch: 16 }, // Invoice Quantity
   { wch: 18 }, // Received Quantity
   { wch: 14 }, // Dock Number
   { wch: 20 }, // Dock In Time
   { wch: 20 }, // Dock Out Time
   { wch: 16 }, // Vehicle Number
   { wch: 18 }, // Vehicle Temperature
   { wch: 18 }, // Location
   { wch: 24 }, // Batch Number
   { wch: 35 }, // Manufacturing Date
   { wch: 35 }, // Expiry Date
   { wch: 20 }, // Batch Quantity
   { wch: 25 }, // Condition
   { wch: 30 }, // Bin Code
 ];

  // Data validation for Condition column (P column now)
  const startRow = 3; // samples start from row 3 (1-indexed in Excel)
  const endRow = 5000;

  ws["!dataValidation"] = [
    {
      type: "list",
      allowBlank: 1,
      sqref: `R${startRow}:R${endRow}`,
      formulas: ['"GOOD,DAMAGED,EXPIRED"'],
    },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
